import '../css/index.css';
import portfolioModal from './portfolioModal';

portfolioModal();
